export default "__VITE_ASSET__Bmw5HkjO__"